module.exports = __webpack_public_path__ + "static/media/lolyListing.6413fd32.png";